import ArchetypeObserver from './ArchetypeObserver'

export default ArchetypeObserver
// eslint-disable-next-line import/export
export * from './ArchetypeObserver'
